interface UseTokenReturn {
  get: (name: string) => string | null
  set: (name: string, tokenValue: string) => void
  destroy: () => void
}

const useToken = (): UseTokenReturn => {
  const get = (name: string) => window.localStorage.getItem(name)
  const set = (name: string, tokenValue: string) => window.localStorage.setItem(name, tokenValue)
  const destroy = () => window.localStorage.removeItem('hop-telecom-auth')

  return {
    get,
    set,
    destroy,
  }
}

export default useToken
